import { render, staticRenderFns } from "./d-search-result-book.vue?vue&type=template&id=3ed243b4&scoped=true&"
import script from "./d-search-result-book.vue?vue&type=script&lang=js&"
export * from "./d-search-result-book.vue?vue&type=script&lang=js&"
import style0 from "./d-search-result-book.vue?vue&type=style&index=0&id=3ed243b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed243b4",
  null
  
)

export default component.exports